<template>
  <div class="footer" :style="'background: url('+bg+') no-repeat center;'">
    <div class="fd-con">
      <dl style="margin-right:50px">
        <dt>关于产品</dt>
        <dd>
          <dd v-for="(item,i) in setCatefoot"  @click="$router.push('product')"><a href="javascript:;">{{item.title}}</a></dd>
        </dd>
      </dl>
      <!--<dl>
        <dt>应用场景</dt>
        <dd>
          <dd v-for="(item,i) in setTradefoot"  @click="$router.push('trade?id='+item.id)"><a href="javascript:;" >{{item.title}}</a></dd>
        </dd>
      </dl>-->
      <dl>
        <dt>新闻中心</dt>
        <dd><a href="javascript:;"  @click="$router.push('news')">新闻中心</a></dd>
      </dl>
      <dl>
        <dt>关于我们</dt>
        <dd><a href="javascript:;"  @click="$router.push('about')">企业介绍</a></dd>
        <dd><a href="javascript:;"  @click="$router.push('hire')">人员招聘</a></dd>
      </dl>
      <dl>
        <dt>联系我们</dt>
        <dd>0771-5383552</dd>
        <dd>广西钦州市钦南区大番坡镇金窝工业园区一期</dd>
        <dd>CLKJ@zhjtg.com</dd>
        <dd><img src="~assets/images/code.jpg"></dd>
      </dl>
    </div>
    <div class="copy">Copyright © 2024-2025 www.canglongtech.com 广西沧龙科技有限公司<br>桂ICP备2025073857号，桂ICP备2025073857号-1</div>
  </div>
</template>
<script >
  import $ from 'jquery'
  export default {
    data() {
      return {
        bg:require('../../assets/images/footer.png'),
        setTradefoot:[],
        setCatefoot:[]
      }
    },

    mounted() {
      //this.getTradefoot();
      this.getCatefoot();
    },

    methods: {
      getTradefoot:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/trade',
          dataType:'json',
          success:function(data){
            that.setTradefoot = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getCatefoot:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/cate',
          dataType:'json',
          success:function(data){
            that.setCatefoot = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    }
  }
</script>

<style>
  .footer{
    display:block;
    width:100%;
    background-size: 100% 100% !important;
  }
  .footer .fd-con{
    padding: 6.25vw 0;
    max-width:1600px;
    margin:0 auto
  }
  .footer .fd-con dl{
    display:inline-block;
    width:200px;
    vertical-align: top;
  }
  .footer .fd-con dl dt{
    color:#fff;
    font-size:17px;
    margin-bottom:22px;
    font-weight:bold;
  }
  .footer .fd-con dl dd{
    margin-bottom:15px;
    line-height:22px
  }
  .footer .fd-con dl dd a{
    color:#fff;
    font-size:13px;
  }
  .footer .fd-con dl:last-child{
    float:right;
    margin-right:25%;
    width:20%
  }
  .footer .fd-con dl:last-child dd{
    color:#fff;
    font-size:13px;
  }
  .footer .fd-con dl:last-child dd img{
    width:100px
  }
  .footer .copy{
    text-align:center;
    line-height:24px;
    padding:12px 0;
    font-size:14px;
    color:#fff
  }
  @media only screen and (max-width: 1199px) {
    .footer .fd-con{
      display:none
    }
  }
</style>
